import { PayloadAction, createSlice, current } from "@reduxjs/toolkit";

import { getState, saveState } from "./global";

import { tServiceProvider, tServicePackage } from "./types/app.types";

type numType = number | "";

type tPayBillsMini = {
  serviceProvider: tServiceProvider | null;
  newBeneficiary: boolean;
  alias: string;
};

type PayBillsType = {
  airtime: tPayBillsMini & {
    phoneNumber: numType;
    amount: numType;
  };
  data: tPayBillsMini & {
    servicePackage: tServicePackage | null;
    phoneNumber: numType;
  };
  cable: tPayBillsMini & {
    servicePackage: tServicePackage | null;
    recipient: numType;
    verification: string;
  };
  electricity: tPayBillsMini & {
    recipient: numType;
    amount: numType;
    verification: string;
  };
};

const PayBillsInitialState: PayBillsType = {
  airtime: {
    serviceProvider: null,
    phoneNumber: "",
    amount: "",
    newBeneficiary: false,
    alias: "",
  },
  data: {
    serviceProvider: null,
    servicePackage: null,
    phoneNumber: "",
    newBeneficiary: false,
    alias: "",
  },
  cable: {
    serviceProvider: null,
    servicePackage: null,
    recipient: "",
    verification: "",
    newBeneficiary: false,
    alias: "",
  },
  electricity: {
    serviceProvider: null,
    recipient: "",
    amount: "",
    verification: "",
    newBeneficiary: false,
    alias: "",
  },
};

const paybillsSlice = createSlice({
  name: "paybills",
  initialState: getState<PayBillsType>("paybills", PayBillsInitialState),
  reducers: {
    updateAirtime(state, { payload }: PayloadAction<PayBillsType["airtime"]>) {
      state.airtime = payload;

      saveState("paybills", current(state));
    },
    updateData(state, { payload }: PayloadAction<PayBillsType["data"]>) {
      state.data = payload;

      saveState("paybills", current(state));
    },
    updateCable(state, { payload }: PayloadAction<PayBillsType["cable"]>) {
      state.cable = payload;

      saveState("paybills", current(state));
    },
    updateElectricity(
      state,
      { payload }: PayloadAction<PayBillsType["electricity"]>
    ) {
      state.electricity = payload;

      saveState("paybills", current(state));
    },
    clearBillData(state, { payload }: PayloadAction<keyof PayBillsType>) {
      state[payload] = PayBillsInitialState[payload] as any; // Never use any

      saveState("paybills", current(state));
    },
  },
});

export const {
  updateAirtime,
  updateData,
  updateCable,
  updateElectricity,
  clearBillData,
} = paybillsSlice.actions;

export default paybillsSlice.reducer;
